<template>
  <div class="mx-auto my-10 max-w-lg">
    <div class="bg-white overflow-hidden shadow rounded-lg mt-10">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h1>Order notifications</h1>
      </div>
      <div class="px-4 py-5 sm:p-6">
        <div class="mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500">
          With this feature you could send your customers about order updates
        </div>
      </div>
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="sm:flex sm:items-end sm:justify-end">
            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                  type="button"
                  @click="enable"
                  :disabled="isEnabling"
                >
                  <span
                    class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                    >Enable</span
                  >
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderOnboarding",
  data() {
    return {
      isEnabling: false
    };
  },
  methods: {
    enable() {
      this.isEnabling = true;
      this.$store
        .dispatch("enableOrderNotifications")
        .then(() => {
          return this.$store.dispatch("getConfig");
        })
        .then(() => {
          this.isEnabling = false;
        })
        .catch(() => {
          this.isEnabling = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
